import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { UserPlus } from 'lucide-react';
import { LEAD_SOURCES } from '../constants';

export const AddLeadDialog = ({ 
  open, 
  onOpenChange, 
  newLead, 
  setNewLead, 
  projects, 
  onSubmit 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus className="h-5 w-5" />
            Add New Lead
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Name *</Label>
              <Input 
                value={newLead.name}
                onChange={(e) => setNewLead({...newLead, name: e.target.value})}
                placeholder="Lead name"
                data-testid="new-lead-name"
              />
            </div>
            <div className="space-y-2">
              <Label>Phone *</Label>
              <Input 
                value={newLead.phone}
                onChange={(e) => setNewLead({...newLead, phone: e.target.value})}
                placeholder="+91 XXXXX XXXXX"
                data-testid="new-lead-phone"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Email</Label>
            <Input 
              type="email"
              value={newLead.email}
              onChange={(e) => setNewLead({...newLead, email: e.target.value})}
              placeholder="email@example.com"
              data-testid="new-lead-email"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Source</Label>
              <Select value={newLead.source} onValueChange={(v) => setNewLead({...newLead, source: v})}>
                <SelectTrigger data-testid="new-lead-source">
                  <SelectValue placeholder="Select source" />
                </SelectTrigger>
                <SelectContent>
                  {LEAD_SOURCES.map(s => (
                    <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Project</Label>
              <Select value={newLead.project_id} onValueChange={(v) => setNewLead({...newLead, project_id: v})}>
                <SelectTrigger data-testid="new-lead-project">
                  <SelectValue placeholder="Select project" />
                </SelectTrigger>
                <SelectContent>
                  {projects.map(p => (
                    <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>BHK Preference</Label>
              <Select value={newLead.bhk_preference} onValueChange={(v) => setNewLead({...newLead, bhk_preference: v})}>
                <SelectTrigger>
                  <SelectValue placeholder="Select BHK" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="1 BHK">1 BHK</SelectItem>
                  <SelectItem value="2 BHK">2 BHK</SelectItem>
                  <SelectItem value="3 BHK">3 BHK</SelectItem>
                  <SelectItem value="4 BHK">4 BHK</SelectItem>
                  <SelectItem value="5+ BHK">5+ BHK</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Budget (₹)</Label>
              <Input 
                type="number"
                value={newLead.budget}
                onChange={(e) => setNewLead({...newLead, budget: e.target.value})}
                placeholder="e.g., 5000000"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Remarks</Label>
            <Textarea 
              value={newLead.remarks}
              onChange={(e) => setNewLead({...newLead, remarks: e.target.value})}
              placeholder="Additional notes..."
              rows={2}
            />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSubmit} data-testid="submit-new-lead-btn">Create Lead</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
